export default "__VITE_ASSET__DUA3D6Oc__"